import React from 'react'
import { object } from 'prop-types'
import { FooterPersonalized } from './App.js'
import './index.scss'

export default class MPersonalizedFooter extends React.Component {
  render() {
    const { contentIdentifier } = this.props.content
    return <FooterPersonalized contentIdentifier={contentIdentifier} />
  }
}

MPersonalizedFooter.propTypes = {
  content: object,
}

MPersonalizedFooter.defaultProps = {
  content: {},
}
